import { Trash2, Plus } from 'lucide-react'
import { Button, Checkbox, Input } from '@/components/ui'
import { blankCommodityLine } from '../api/types'
import type { BolCommodityLine } from '../api/types'

interface Props {
  lines: BolCommodityLine[]
  onChange: (lines: BolCommodityLine[]) => void
}

export function CommodityLinesEditor({ lines, onChange }: Props) {
  const rows = lines.length > 0 ? lines : [blankCommodityLine()]

  function update<K extends keyof BolCommodityLine>(idx: number, field: K, value: BolCommodityLine[K]) {
    onChange(rows.map((line, i) => (i === idx ? { ...line, [field]: value } : line)))
  }

  function addRow() {
    onChange([...rows, blankCommodityLine()])
  }

  function removeRow(idx: number) {
    onChange(rows.length === 1 ? [blankCommodityLine()] : rows.filter((_, i) => i !== idx))
  }

  return (
    <div className="space-y-2 overflow-x-auto">
      <div className="grid grid-cols-[0.8fr_1fr_0.8fr_1fr_0.8fr_0.5fr_2fr_0.8fr_0.6fr_36px] gap-2 px-1 min-w-[900px]">
        {['HU Qty', 'HU Type', 'Pkg Qty', 'Pkg Type', 'Weight', 'HM', 'Commodity Description', 'NMFC #', 'Class', ''].map((h) => (
          <span key={h} className="text-xs font-medium text-secondary uppercase tracking-wide">{h}</span>
        ))}
      </div>
      {rows.map((line, idx) => (
        <div key={idx} className="grid grid-cols-[0.8fr_1fr_0.8fr_1fr_0.8fr_0.5fr_2fr_0.8fr_0.6fr_36px] gap-2 items-start min-w-[900px]">
          <Input value={line.handling_unit_qty} onChange={(e) => update(idx, 'handling_unit_qty', e.target.value)} placeholder="Qty" />
          <Input value={line.handling_unit_type} onChange={(e) => update(idx, 'handling_unit_type', e.target.value)} placeholder="Pallet" />
          <Input value={line.package_qty} onChange={(e) => update(idx, 'package_qty', e.target.value)} placeholder="Qty" />
          <Input value={line.package_type} onChange={(e) => update(idx, 'package_type', e.target.value)} placeholder="Drum" />
          <Input value={line.weight} onChange={(e) => update(idx, 'weight', e.target.value)} placeholder="Weight" />
          <div className="flex items-center h-8">
            <Checkbox checked={line.hazmat} onChange={(e) => update(idx, 'hazmat', e.target.checked)} />
          </div>
          <Input value={line.description} onChange={(e) => update(idx, 'description', e.target.value)} placeholder="Commodity description" />
          <Input value={line.nmfc} onChange={(e) => update(idx, 'nmfc', e.target.value)} placeholder="NMFC #" />
          <Input value={line.freight_class} onChange={(e) => update(idx, 'freight_class', e.target.value)} placeholder="Class" />
          <button type="button" onClick={() => removeRow(idx)} className="h-8 w-8 flex items-center justify-center rounded text-secondary hover:text-danger hover:bg-danger/10 transition-colors" title="Remove line">
            <Trash2 size={14} />
          </button>
        </div>
      ))}
      <Button variant="ghost" size="sm" onClick={addRow} className="mt-1">
        <Plus size={14} className="mr-1" /> Add line
      </Button>
    </div>
  )
}
